export const BANK_ACCOUNT_TYPES = {
  1: 'Saving',
  2: 'Checking',
}

export const BANK_HOLDER_TYPES = {
  1: 'Personal',
  2: 'Business',
}
